import React from 'react';
import '../styles/Footer.css';
import { useNavigate, Navigate } from 'react-router-dom';
import { SocialMediaLinks } from './SocialMediaLinks';

const footerSections = [
  {
    title: 'Programs',
    links: [
      { label: 'All Programs', href: '/programs' },
      { label: 'Find Your Program', href: '/#program-quiz' },
      { label: 'Success Stories', href: '/#testimonials' },
      { label: 'Start Here', href: '/#programs' },
    ],
  },
  {
    title: 'Explore',
    links: [
      { label: 'Home', href: '/' },
      { label: 'Why It Works', href: '/#why-it-works' },
      { label: 'About Daniella', href: '/about' },
      { label: 'Contact', href: '/contact' },
    ],
  },
  {
    title: 'Company',
    links: [
      { label: 'Blog', href: '/blogs' },
      { label: 'Testimonials', href: '/#testimonials' },
      { label: 'Program Quiz', href: '/#program-quiz' },
      { label: 'Browse Programs', href: '/programs' },
    ],
  },
  {
    title: 'Legal & Compliance',
    links: [
      { label: 'Privacy Policy', href: '/legal/#privacy-policy' },
      { label: 'Terms & Conditions', href: '/legal/#terms-and-conditions' },
      { label: 'Medical Disclaimer', href: '/legal/#medical-disclaimer' },
      { label: 'Refund Policy', href: '/legal/#refund-policy' },
      { label: 'Cookie Policy', href: '/legal/#cookie-policy' }
    ],
  }
];

export function Footer() {
  const navigate = useNavigate();
  const onNagationChange = (selLink) => {
    const [, pathWithHash = ""] = selLink.split("/");

    const [path, hash] = pathWithHash.split("#");

    navigate(`/${path}${hash ? `#${hash}` : ""}`);

    if (!hash) {
      window.scrollTo({
        top: 0,
        behavior: "smooth",
      });
    }
  };

  return (
    <footer className="footer">
      <div className="footer-container">
        <div className="footer-grid">
          <div className="footer-brand">
            <h3 className="footer-logo">
              Get Fit with <span className="footer-logo-highlight">Daniella</span>
            </h3>
            <p className="footer-description">
              Bringing fun and sustainability into your fitness journey.
              {' '}
              Join learners across 50+ countries.
            </p>
          </div>

          {footerSections.map((section) => (
            <div key={section.title} className="footer-links-section">
              <h4 className="footer-heading">{section.title}</h4>
              <ul className="footer-links">
                {section.links.map((link) => (
                  <li key={link.label}>
                    {/* <a href={link.href} className="footer-link">
                      {link.label}
                    </a> */}
                    <button onClick={() => onNagationChange(link.href)} className="footer-link">
                      {link.label}
                    </button>
                  </li>
                ))}
              </ul>
            </div>
          ))}
        </div>

        <div className="footer-divider"></div>
        <SocialMediaLinks />
        <div className="footer-bottom">
          <p>&copy; {new Date().getFullYear()} Get Fit with Daniella. All rights reserved.</p>
        </div>
      </div>
    </footer>
  );
}